import styled from 'styled-components'
import TargetBlank from 'li-components/lib/TargetBlank'
import BaseRule from 'li-components/lib/Modal2/Rule'
import vars from 'li-components/lib/styles'
import { SidebarHeader } from '../../components/styled'

export const Header = SidebarHeader.extend`
  color: white;
  background-color: ${vars.brandPrimaryAccessible};
  border: 0;

  h2 {
    color: ${vars.white};
  }
`

export const Article = styled.li`
  border-bottom: 2px solid ${vars.grayLighter};

  > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem;
    color: ${vars.textColor};
    text-decoration: none;
    cursor: pointer;

    > em {
      font-weight: 600;
      font-style: normal;
    }
  }

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  svg {
    width: 1em;
    height: 1em;
    fill: ${vars.brandPrimary};
  }
`

export const ArticleBody = styled.div`
  padding: 2rem;
  color: ${vars.textColor};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: ${vars.textColor};
  }

  a {
    color: ${vars.brandPrimary};
    text-decoration: none;
  }

  ol li,
  ul li {
    margin-bottom: 1rem;
    list-style-position: inside;
    text-indent: -1.33em;
  }

  > main,
  > header {
    iframe,
    img {
      width: 100%;
      height: auto;
    }
  }

  footer a {
    display: flex;
    justify-content: space-between;
  }
`

export const ViewAllLink = styled.li`
  padding: 2rem;
  text-align: center;

  a {
    color: ${vars.brandPrimary};
  }
`

export const MenuItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-content: center;
  min-height: 4rem;
  border-top: 2px solid ${vars.cardBorderColor};
  cursor: pointer;

  > a,
  > span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1rem 2rem;
    color: ${vars.textColor};
    text-decoration: none;
  }

  h4 {
    margin: 0;
  }

  .SvgIcon {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  svg {
    width: 1em;
    height: 1em;
    fill: ${vars.brandPrimary};
  }

  .large svg {
    width: 1.5em;
    height: 1.5em;
  }
`

export const MenuItemBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  margin-left: auto;
  margin-right: 1rem;
  border-radius: 50%;
  color: ${vars.white};
  background-color: ${vars.brandPrimaryAccessible};
  font-weight: 600;
`

export const ArticleLink = styled(TargetBlank)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const SecondaryPage = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 70px);
  overflow: hidden;

  > header {
    width: 100%;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    padding: 1rem 2rem;
    border-bottom: 2px solid ${vars.cardBorderColor};
    background-color: ${vars.white};
    color: ${vars.textColor};
    font-weight: 600;

    cursor: pointer;
    > button {
      margin: 0;
      margin-right: 0.5rem;
    }

    > h3 {
      margin: 0;
    }
  }

  > main {
    padding: 2rem;
    flex: 1 1 auto;
    overflow: auto;

    > form {
      flex: 0 0 auto;
      height: 100%;
    }
  }

  > footer {
    flex: 0 0 auto;
    padding: 2rem;
    border-top: 2px solid ${vars.cardBorderColor};
  }
`

export const Rule = styled(BaseRule)`
  margin: 1rem 0;
`



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/styled.js